import React from "react";
import { iconProps } from "../../Helper";

const TextSuitIcon = ({ className, size }: iconProps) => {
  return (
    <svg
      width={size ? size : "57"}
      height={size ? size : "58"}
      viewBox="0 0 57 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className={className}
        d="M12.7344 44.696H34.401V39.696H12.7344V44.696ZM12.7344 31.3626H44.401V26.3626H12.7344V31.3626ZM12.7344 18.0293H44.401V13.0293H12.7344V18.0293ZM6.26021 57.196C4.57632 57.196 3.15104 56.6126 1.98438 55.446C0.817708 54.2793 0.234375 52.854 0.234375 51.1701V6.55513C0.234375 4.87124 0.817708 3.44596 1.98438 2.2793C3.15104 1.11263 4.57632 0.529297 6.26021 0.529297H50.8752C52.5591 0.529297 53.9844 1.11263 55.151 2.2793C56.3177 3.44596 56.901 4.87124 56.901 6.55513V51.1701C56.901 52.854 56.3177 54.2793 55.151 55.446C53.9844 56.6126 52.5591 57.196 50.8752 57.196H6.26021ZM6.26021 52.196H50.8752C51.1319 52.196 51.3669 52.089 51.5802 51.8751C51.7941 51.6618 51.901 51.4268 51.901 51.1701V6.55513C51.901 6.29846 51.7941 6.06346 51.5802 5.85013C51.3669 5.63624 51.1319 5.5293 50.8752 5.5293H6.26021C6.00354 5.5293 5.76854 5.63624 5.55521 5.85013C5.34132 6.06346 5.23438 6.29846 5.23438 6.55513V51.1701C5.23438 51.4268 5.34132 51.6618 5.55521 51.8751C5.76854 52.089 6.00354 52.196 6.26021 52.196Z"
        fill="white"
      />
    </svg>
  );
};

export default TextSuitIcon;
